import { useEffect, useRef } from "react";
import React from "react";
import EngineHeader from "../Equip2/EngineHeader";
import { Card, CardBody, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
// ADD THESE IMPORTS
import axios from "axios";
import { useState } from "react";
// ─── Static Data ─────────────────────────────────────────────────────────────
// const SENSORS = [
//   { label: "Engine Running",     value: "Normal", unit: "",    dot: "#16a34a" },
//   { label: "Load Demand",        value: "72",     unit: "%"   },
//   { label: "Governor Mode",      value: "Auto",   unit: ""    },
//   { label: "Start Mode",         value: "Remote", unit: ""    },
//   { label: "Cooling Water Temp", value: "75",     unit: " °C" },
//   { label: "Lub. Oil Pressure",  value: "4.6",    unit: " bar"},
//   { label: "Fuel Temperature",   value: "38",     unit: " °C" },
//   { label: "Charge Air Temp",    value: "55",     unit: " °C" },
//   { label: "Exhaust Gas Temp",   value: "412",    unit: " °C" },
// ];

const KPI_DATA = [
  { label: "POWER OUTPUT",    value: "5,288", unit: "kW",    sub: "72% Load", pct: 72, labelColor: "#2563eb", subColor: "#64748b",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
    iconBg: "#eff6ff", valueColor: "#0f172a" },

  { label: "SPEED",           value: "900",   unit: "RPM",   sub: "Nominal",  pct: 45, labelColor: "#16a34a", subColor: "#16a34a",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    iconBg: "#f0fdf4", valueColor: "#0f172a" },

  { label: "VOLTAGE",         value: "454",   unit: "V",     sub: "Nominal",  pct: 45, labelColor: "#16a34a", subColor: "#16a34a",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
    iconBg: "#f0fdf4", valueColor: "#0f172a" },

  { label: "FREQUENCY",       value: "59.9",  unit: "Hz",    sub: "Nominal",  pct: 60, labelColor: "#16a34a", subColor: "#16a34a",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12 Q5 4 8 12 Q11 20 14 12 Q17 4 20 12"/></svg>,
    iconBg: "#f0fdf4", valueColor: "#0f172a" },

  { label: "POWER FACTOR",    value: "0.96",  unit: "",      sub: "Good",     pct: 96, labelColor: "#16a34a", subColor: "#16a34a",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/></svg>,
    iconBg: "#f0fdf4", valueColor: "#0f172a" },

  { label: "FUEL CONSUMPTION", value: "180",  unit: "g/kWh", sub: "Optimal",  pct: 55, labelColor: "#dc2626", subColor: "#16a34a",
    icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 22V8l9-6 9 6v14"/><path d="M10 14h4v8h-4z"/></svg>,
    iconBg: "#fef2f2", valueColor: "#dc2626" },
];
const sysBadges = [
  { icon: "⚙", label: "SYSTEM",      status: "Normal" },
  { icon: "⛽", label: "FUEL SYSTEM", status: "Normal" },
  { icon: "🛢", label: "LUBRICATION", status: "Normal" },
  { icon: "❄", label: "COOLING",     status: "Normal" },
  { icon: "💨", label: "AIR SYSTEM",  status: "Normal" },
  { icon: "💨", label: "EXHAUST",     status: "Normal" },
];
const CYLINDER_DATA   = [98, 101, 97, 100, 99, 98];
const EXH_TEMP_DATA   = [405, 418, 412, 408, 415, 420];
const FUEL_TREND_DATA = [175, 182, 178, 185, 180, 176, 183, 179, 181, 184, 178, 182, 180];
const FUEL_LABELS     = ["00:00","02:00","04:00","06:00","08:00","10:00","12:00","14:00","16:00","18:00","20:00","22:00","24:00"];
const CYL_LABELS      = ["Cyl.1","Cyl.2","Cyl.3","Cyl.4","Cyl.5","Cyl.6"];

const DARK_GRID = "rgba(200,210,225,0.5)";
const TICK      = "#94a3b8";
const baseOpts  = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
    y: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
  },
};

// ─── SVG Arc Gauge (matches screenshot style) ────────────────────────────────
function Gauge({ label, value, unit, color, pct }) {
  const radius = 38;
  const cx = 56, cy = 52;
  const startAngle = -210;
  const endAngle   = 30;
  const totalArc   = endAngle - startAngle;
  const fillArc    = totalArc * Math.min(Math.max(pct, 0), 1);

  function polarToXY(angleDeg, r) {
    const rad = (angleDeg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function arcPath(fromDeg, toDeg, r) {
    const s = polarToXY(fromDeg, r);
    const e = polarToXY(toDeg, r);
    const large = toDeg - fromDeg > 180 ? 1 : 0;
    return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
  }

  const bgPath   = arcPath(startAngle, endAngle, radius);
  const fillPath = arcPath(startAngle, startAngle + fillArc, radius);

  // Tick marks
  const ticks = [];
  for (let i = 0; i <= 10; i++) {
    const a = startAngle + (totalArc * i) / 10;
    const inner = polarToXY(a, radius - 5);
    const outer = polarToXY(a, radius - 1);
    ticks.push({ x1: inner.x, y1: inner.y, x2: outer.x, y2: outer.y });
  }

  return (
    <div style={s.gaugeWrap}>
      <svg width="112" height="72" viewBox="0 0 112 72">
        {/* Track */}
        <path d={bgPath} fill="none" stroke="#e2e8f0" strokeWidth="7" strokeLinecap="round"/>
        {/* Fill */}
        <path d={fillPath} fill="none" stroke={color} strokeWidth="7" strokeLinecap="round"/>
        {/* Tick marks */}
        {ticks.map((t, i) => (
          <line key={i} x1={t.x1} y1={t.y1} x2={t.x2} y2={t.y2}
            stroke={i % 5 === 0 ? "#94a3b8" : "#d1d5db"} strokeWidth={i % 5 === 0 ? 1.5 : 0.8}/>
        ))}
        {/* Value */}
        <text x={cx} y={cy - 4} textAnchor="middle"
          fontFamily="'Share Tech Mono', 'Courier New', monospace"
          fontSize="13" fill="#1e293b" fontWeight="700">{value}</text>
        {/* Unit */}
        <text x={cx} y={cy + 10} textAnchor="middle"
          fontFamily="sans-serif" fontSize="9" fill="#94a3b8">{unit}</text>
      </svg>
      <div style={s.gaugeLabel}>{label}</div>
    </div>
  );
}

// ─── KPI Card (matches screenshot: icon, value, progress bar, sub-label) ────
function KpiCard({ label, value, unit, sub, pct, color,icon }) {
  return (
    <div style={s.kpiCard}>
      <div>{icon}</div>
      <div style={s.kpiLabel}>{label}</div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 4, margin: "4px 0 2px" }}>
        <span style={{ ...s.kpiValue, color }}>{value}</span>
        {unit && <span style={s.kpiUnit}>{unit}</span>}
      </div>
      <div style={s.kpiBar}>
        <div style={{ ...s.kpiBarFill, width: `${pct}%`, background: color }}/>
      </div>
      <div style={s.kpiSub}>{sub}</div>
    </div>
  );
}

// ─── Main Component ──────────────────────────────────────────────────────────
export default function AuxiliaryEngine1({ activeAE = "" }) {
  const cylRef    = useRef(null);
  const exhRef    = useRef(null);
  const fuelRef   = useRef(null);
  const chartsRef = useRef([]);
// ADD THESE STATES INSIDE COMPONENT
// ADD THESE STATES INSIDE COMPONENT
 const toMayDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  return `2026-05-${day}`;
};

const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0]
);
const [dashboardData, setDashboardData] = useState([]);
const [engineStatus, setEngineStatus] = useState([]);
const [showAllStatus, setShowAllStatus] = useState(false);
const [loading, setLoading] = useState(false)
const [dgStatus, setDgStatus] = useState([]);
const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}:00`; // always sends seconds as :00
};
  useEffect(() => {
    function initCharts() {
      const Chart = window.Chart;
      if (!Chart) return;
      chartsRef.current.forEach(c => c.destroy());
      chartsRef.current = [];

      if (cylRef.current) {
        chartsRef.current.push(new Chart(cylRef.current, {
          type: "bar",
          data: {
            labels: CYL_LABELS,
            datasets: [{
              data: CYLINDER_DATA,
              backgroundColor: "rgba(37,99,235,0.15)",
              borderColor: "#2563eb",
              borderWidth: 1.5,
              borderRadius: 4,
            }],
          },
          options: {
            ...baseOpts,
            scales: {
              x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
              y: {
                grid: { color: DARK_GRID },
                ticks: { color: TICK, font: { size: 10 }, callback: v => v + "%" },
                min: 80, max: 110,
              },
            },
          },
        }));
      }

      if (exhRef.current) {
        chartsRef.current.push(new Chart(exhRef.current, {
          type: "line",
          data: {
            labels: CYL_LABELS,
            datasets: [{
              data: EXH_TEMP_DATA,
              borderColor: "#2563eb",
              backgroundColor: "rgba(37,99,235,0.06)",
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "#2563eb",
              fill: true,
              tension: 0.3,
            }],
          },
          options: {
            ...baseOpts,
            scales: {
              x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
              y: {
                grid: { color: DARK_GRID },
                ticks: { color: TICK, font: { size: 10 }, callback: v => v + "°" },
                min: 380, max: 440,
              },
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: ctx => `${ctx.parsed.y} °C`,
                  afterBody: items => {
                    const mean = Math.round(EXH_TEMP_DATA.reduce((a, b) => a + b, 0) / EXH_TEMP_DATA.length);
                    const dev  = items[0].parsed.y - mean;
                    return `Dev: ${dev >= 0 ? "+" : ""}${dev}`;
                  },
                },
              },
            },
          },
        }));
      }

      if (fuelRef.current) {
        chartsRef.current.push(new Chart(fuelRef.current, {
          type: "line",
          data: {
            labels: FUEL_LABELS,
            datasets: [{
              data: FUEL_TREND_DATA,
              borderColor: "#2563eb",
              backgroundColor: "rgba(37,99,235,0.05)",
              borderWidth: 2,
              pointRadius: 2,
              fill: true,
              tension: 0.4,
            }],
          },
          options: {
            ...baseOpts,
            scales: {
              x: {
                grid: { color: DARK_GRID },
                ticks: { color: TICK, font: { size: 9 }, maxRotation: 0, autoSkip: true, maxTicksLimit: 6 },
              },
              y: {
                grid: { color: DARK_GRID },
                ticks: { color: TICK, font: { size: 10 } },
                min: 160, max: 200,
              },
            },
          },
        }));
      }
    }

    if (window.Chart) {
      initCharts();
    } else {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/chart.js@4.4.0/dist/chart.umd.min.js";
      script.onload = initCharts;
      document.head.appendChild(script);
    }

    return () => { chartsRef.current.forEach(c => c.destroy()); chartsRef.current = []; };
  }, []);
// ADD THIS useEffect INSIDE COMPONENT
 const currentTime = getCurrentTime();
useEffect(() => {
  fetchDashboardData(selectedDate,currentTime);
}, [selectedDate,currentTime]);

useEffect(() => {
    fetchDashboardData(selectedDate, currentTime);

    const interval = setInterval(() => fetchDashboardData(selectedDate, currentTime), 60000);

    return () => clearInterval(interval);
  }, [selectedDate, currentTime]);



  const fetchDgStatus = async () => {
  try {

    const apiDate = toMayDate(selectedDate);
    const response = await axios.get(
      `https://api.hanoch.in/api/dg-running-status/?date=${apiDate}&time=${getCurrentTime()}`
    );
    if (response.data?.success) {
      setDgStatus(response.data.data);
    }
  } catch (error) {
    console.log("DG Status API Error:", error);
  }
};

useEffect(() => {
  fetchDgStatus();
  const interval = setInterval(fetchDgStatus, 60000);
  return () => clearInterval(interval);
}, [selectedDate]);

const aeAssetMap = { AE1: "DG-1", AE2: "DG-2", AE3: "DG-3", AE4: "DG-4" };

const getAeRunning = (aeKey) => {
  const entry = dgStatus.find((d) => d.asset === aeAssetMap[aeKey]);
  return entry ? entry.is_running : null; // null = unknown
};
// ADD THIS FUNCTION INSIDE COMPONENT

const fetchDashboardData = async (selectedDate, currentTime) => {
  try {
    setLoading(true);
    const apiDate = toMayDate(selectedDate);
    const response = await axios.get(
      `https://api.hanoch.in/api/ae1-dashboard/?date=${apiDate}&time=${currentTime}`
    );
 
    if (response.success) {
      setDashboardData(response.sections);

      // FLATTEN ALL METRICS FROM ALL SECTIONS
      const allMetrics = response.sections.flatMap((section) =>
        section.metrics.map((metric) => ({
          section: section.title,
          label: metric.label,
          value: metric.value,
          unit: metric.unit || "",
          status: metric.status,
          type: metric.type,
          timestamp: metric.timestamp,
          dot:
            metric.status === "normal"
              ? "#16a34a"
              : metric.status === "critical"
              ? "#dc2626"
              : "#f59e0b",
        }))
      );

      setEngineStatus(allMetrics);
    }
  } catch (error) {
    console.log("Dashboard API Error:", error);
  } finally {
    setLoading(false);
  }
};
  return (
    <React.Fragment>
      <div className="page-content">
          <Card className="em-card">
            <EngineHeader 
            activePage="Auxiliary Engine" 
            activeAE="AE1"
            selectedDate={selectedDate}
  setSelectedDate={setSelectedDate}
            />

            <CardBody className="em-body">
              <Row className="g-2">

                {/* ── AE Sub-Nav ── */}
               {/* ── AE Sub-Nav ── */}
<div className="em-nav">
  {[
    { key: "AE1", to: "/auxiliaryEngine1" },
    { key: "AE2", to: "/auxiliaryEngine2" },
    { key: "AE3", to: "/auxiliaryEngine3" },
    { key: "AE4", to: "/auxiliaryEngine4" },
  ].map(({ key, to }) => {
    const isRunning = getAeRunning(key);
    return (
      <button
        key={key}
        className={`em-nb${key === "AE1" ? " em-nb-active" : ""}`}
      >
        <Link to={to} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          {/* Running indicator dot */}
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              display: "inline-block",
              flexShrink: 0,
              background:
                isRunning === true
                  ? "#22c55e"           // green  – running
                  : isRunning === false
                  ? "#ef4444"           // red    – stopped
                  : "#94a3b8",          // grey   – unknown
              boxShadow:
                isRunning === true
                  ? "0 0 5px #22c55e99"
                  : "none",
            }}
          />
          {key}
        </Link>
      </button>
    );
  })}
</div>

                {/* ── KPI Row ── */}
                <div style={s.kpiGrid}>
                  {KPI_DATA.map((k, i) => <KpiCard key={i} {...k} />)}
                </div>

                {/* ── Main 3-Col Layout ── */}
                <div style={s.mainGrid}>

                  {/* LEFT: Engine Status */}
              {/* LEFT: Engine Status */}
<div style={s.panel}>
  <div style={s.panelTitle}>ENGINE STATUS</div>

  {loading ? (
    <div style={{ padding: 15, textAlign: "center", color: "#64748b" }}>
      Loading...
    </div>
  ) : (
    <div style={{ overflowY: "auto", maxHeight: 300 }}>
      {engineStatus.map((item, i) => {
        // Skip digital items that are not ACTIVE
        if (item.type === "digital" && item.value !== "ACTIVE") return null;

        return (
          <div
            key={i}
            style={{
              ...s.statusRow,
              background: item.status === "critical" ? "#fef2f2" : "transparent",
              borderRadius: 6,
              paddingLeft: 6,
              paddingRight: 6,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <span style={s.sLabel}>{item.label}</span>
              <span style={{ fontSize: 10, color: "#94a3b8" }}>{item.section}</span>
            </div>

            <span style={s.sVal}>
              {item.type === "analog" ? (
                // Analog: show dot + value + unit
                <>
                  {/* <span style={{ ...s.sDot, background: item.dot }} /> */}
                  {item.value} {item.unit}
                </>
              ) : (
                // Digital ACTIVE: green dot + ACTIVE
                <>
                  <span
                    style={{
                      ...s.sDot,
                      background: "#22c55e", // green
                    }}
                  />
                  {item.value}
                </>
              )}
            </span>
          </div>
        );
      })}
    </div>
  )}
</div>
   
  

                  {/* CENTER: Engine Visualization */}
                  <div className="em-right-col">
                    <div className="em-glass em-engine-sectione pt-2 text-left">
                      <h6 style={s.sectionHeading}>Engine Visualization</h6>
                      <img
                        src="/asset/windingtemp.jpeg"
                        alt="Engine diagram"
                        className="em-engine-img"
                      />
                     <div style={s.visTopbar}>
  {sysBadges.map((badge, i) => (
    <span key={i} style={s.sysBadge}>
      <span style={s.sysBadgeIcon}>{badge.icon}</span>
      <span style={{ display: "flex", flexDirection: "column" }}>
        <span style={s.sysBadgeLabel}>{badge.label}</span>
        <span style={s.sysBadgeStatus}>{badge.status}</span>
      </span>
    </span>
  ))}
</div>
                    </div>
                  </div>

                  {/* RIGHT: Real-Time Gauges */}
                  <div style={s.panel}>
                    <div style={s.panelTitle}>REAL TIME GAUGES</div>
                    <div style={s.gaugeGrid}>
                      <Gauge label="Engine Load"   value="72%"  unit=""     color="#2563eb" pct={0.72} />
                      <Gauge label="Fuel Rate"     value="310"  unit="L/hr" color="#d97706" pct={0.50} />
                      <Gauge label="Oil Pressure"  value="4.6"  unit="bar"  color="#16a34a" pct={0.46} />
                      <Gauge label="Coolant Temp." value="75"   unit="°C"   color="#0891b2" pct={0.59} />
                      <Gauge label="Exhaust Temp." value="412"  unit="°C"   color="#dc2626" pct={0.80} />
                      <Gauge label="Intake Air"    value="0.9"  unit="bar"  color="#7c3aed" pct={0.20} />
                    </div>
                  </div>

                </div>

                {/* ── Bottom Charts Row ── */}
                <div style={s.bottomGrid}>

                  <div style={s.panel}>
                    <div style={s.panelTitle}>CYLINDER PERFORMANCE</div>
                    <div style={{ height: 150, position: "relative" }}>
                      <canvas ref={cylRef} />
                    </div>
                    <div style={s.chartNote}>
                      Avg. Power Balance: <span style={{ color: "#16a34a", fontWeight: 700 }}>98.8%</span>
                    </div>
                    <div style={s.legendRow}>
                      <span style={{ ...s.legendDot, background: "#2563eb" }} /> Power Output (%)
                    </div>
                  </div>

                  <div style={s.panel}>
                    <div style={s.panelTitle}>EXHAUST GAS TEMPERATURE (°C)</div>
                    <div style={{ height: 150, position: "relative" }}>
                      <canvas ref={exhRef} />
                    </div>
                    <div style={s.chartNote}>
                      Mean: <span style={{ color: "#d97706", fontWeight: 700 }}>413 °C</span>
                    </div>
                    <div style={s.legendRow}>
                      <span style={{ ...s.legendDot, background: "#2563eb" }} /> Exhaust Temp (°C)
                    </div>
                  </div>

                  <div style={s.panel}>
                    <div style={s.panelTitle}>FUEL CONSUMPTION TREND</div>
                    <div style={{ height: 150, position: "relative" }}>
                      <canvas ref={fuelRef} />
                    </div>
                    <div style={s.chartNote}>
                      Avg 24h: <span style={{ color: "#2563eb", fontWeight: 700 }}>180 g/kWh</span>
                    </div>
                    <div style={s.legendRow}>
                      <span style={{ ...s.legendDot, background: "#2563eb" }} /> Fuel Consumption (g/kWh)
                    </div>
                  </div>

                </div>

                {/* ── Environment + Alarms ── */}
                <div style={s.envAlarmsGrid}>

                  <div style={s.panel}>
                    <div style={s.panelTitle}>ENVIRONMENT</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 2 }}>
                      {[
                        { icon: "🌊", label: "Sea Temp.",         value: "26.4 °C"   },
                        { icon: "🌡", label: "Ambient Temp.",     value: "24.8 °C"   },
                        { icon: "💧", label: "Humidity",          value: "78 %"      },
                        { icon: "🧭", label: "Barometric Press.", value: "1013 mbar" },
                      ].map(({ icon, label, value }, i) => (
                        <div key={i} style={s.envItem}>
                          <span style={{ fontSize: 16 }}>{icon}</span>
                          <div>
                            <div style={s.envLabel}>{label}</div>
                            <div style={s.envValue}>{value}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div style={s.panel}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                      <div style={{ ...s.panelTitle, marginBottom: 0, paddingBottom: 0, borderBottom: "none" }}>
                        ALARMS &amp; WARNINGS
                      </div>
                      <span style={s.viewAllLink}>View All →</span>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
                      {[
                        { count: "0",  label: "Critical", color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
                        { count: "2",  label: "Major",    color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
                        { count: "2",  label: "Minor",    color: "#ca8a04", bg: "#fefce8", border: "#fef08a" },
                        { count: "12", label: "Info",     color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
                      ].map(({ count, label, color, bg, border }, i) => (
                        <div key={i} style={{
                          background: bg,
                          border: `1px solid ${border}`,
                          borderRadius: 8,
                          padding: "5px 5px",
                          textAlign: "center",
                        }}>
                          <div style={{ fontSize: 18, fontWeight: 700, color, lineHeight: 1 }}>{count}</div>
                          <div style={s.alarmLabel}>{label}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                </div>

              </Row>
            </CardBody>
          </Card>
       
      </div>
    </React.Fragment>
  );
}

// ─── Styles ──────────────────────────────────────────────────────────────────
const s = {
  // KPI
  kpiGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    gap: 8,
    padding: "10px 16px",
    width: "100%",
  },
  kpiCard: {
    background: "#ffffff",
    // border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: "10px 14px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  kpiLabel: {
    fontSize: 9,
    color: "#005cdc",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontWeight: 700,
    // fontFamily: "'Rajdhani', sans-serif",
  },
  kpiValue: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1,
    fontFamily: "'Share Tech Mono', 'Courier New', monospace",
  },
  kpiUnit: {
    fontSize: 12,
    color: "#060606",
    fontFamily: "'Rajdhani', sans-serif",
    fontWeight: 600,
  },
  kpiBar: {
    height: 4,
    background: "#e2e8f0",
    borderRadius: 2,
    marginTop: 6,
    overflow: "hidden",
  },
  kpiBarFill: {
    height: "100%",
    borderRadius: 2,
    transition: "width 0.6s ease",
  },
  kpiSub: {
    fontSize: 11,
    color: "#64748b",
    marginTop: 4,
    fontFamily: "'Rajdhani', sans-serif",
    fontWeight: 600,
  },

  // Main grid: status | engine viz | gauges
  mainGrid: {
    display: "grid",
    gridTemplateColumns: "220px 1fr 280px",
    gap: 10,
    padding: "0 16px 10px",
    width: "100%",
  },

   visTopbar: {
    display: "flex",
    gap: 8,
    padding: "10px 14px",
    // borderTop: "1px solid #1e3a5f",
    flexWrap: "wrap",
    // background: "#0f172a",
  },
  sysBadge: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 10px",
    borderRadius: 6,
    // border: "1px solid #1e3a5f",
    background: "#ebfff2",
  },
  sysBadgeIcon: {
    fontSize: 13,
    color: "#22c55e",
  },
  sysBadgeLabel: {
    fontSize: 8.5,
    color: "#94a3b8",          // muted/dark — the system name
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    lineHeight: 1.2,
    fontWeight: 600,
  },
  sysBadgeStatus: {
    fontSize: 10,
    color: "#22c55e",          // green — the Normal value
    fontWeight: 600,
    lineHeight: 1.2,
  },


  sectionHeading: {
    fontSize: 13,
    fontWeight: 700,
    color: "#005cdc",
    margin: "0 0 8px",
    padding: "0 12px",
    fontFamily: "'Rajdhani', sans-serif",
    letterSpacing: "0.05em",
    justifyContent:"start"
  },

  // Generic panel
  panel: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 12,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
  panelTitle: {
    fontSize: 10,
    color: "#005cdc",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    fontWeight: 700,
    fontFamily: "'Rajdhani', sans-serif",
    marginBottom: 10,
    paddingBottom: 6,
    borderBottom: "1px solid #f1f5f9",
  },

  // Engine status rows
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 0",
    borderBottom: "1px solid #f1f5f9",
    fontSize: 12,
    fontFamily: "'Rajdhani', sans-serif",
  },
  sLabel: {
    color: "#64748b",
    fontWeight: 500,
  },
  sVal: {
    color: "#1e293b",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    gap: 5,
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: 12,
  },
  sDot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    display: "inline-block",
  },
  viewAllLink: {
    marginTop: 10,
    fontSize: 11,
    color: "#2563eb",
    cursor: "pointer",
    fontWeight: 700,
    fontFamily: "'Rajdhani', sans-serif",
    letterSpacing: "0.05em",
  },

  // Gauges
  gaugeGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 8,
  },
  gaugeWrap: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: "8px 6px 4px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  gaugeLabel: {
    fontSize: 9,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    fontWeight: 700,
    fontFamily: "'Rajdhani', sans-serif",
    marginTop: 2,
  },

  // Bottom charts
  bottomGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: 10,
    padding: "0 16px 10px",
    width: "100%",
  },
  chartNote: {
    fontSize: 11,
    color: "#94a3b8",
    marginTop: 6,
    fontFamily: "'Rajdhani', sans-serif",
    fontWeight: 600,
  },
  legendRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 10,
    color: "#64748b",
    marginTop: 4,
    fontFamily: "'Rajdhani', sans-serif",
    fontWeight: 600,
  },
  legendDot: {
    width: 10,
    height: 10,
    borderRadius: 2,
    display: "inline-block",
    flexShrink: 0,
  },

  // Environment + Alarms
  envAlarmsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    padding: "0 16px 16px",
    width: "100%",
  },
  envItem: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 2,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  envLabel: {
    fontSize: 9,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontFamily: "'Rajdhani', sans-serif",
    fontWeight: 600,
  },
  envValue: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1e293b",
    fontFamily: "'Share Tech Mono', monospace",
  },
  alarmLabel: {
    fontSize: 10,
    color: "#64748b",
    marginTop: 4,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 700,
    fontFamily: "'Rajdhani', sans-serif",
  },
};